export default{

    setPlayer : ({commit, dispatch}, player) => {
        commit('setPlayerState', player)
        localStorage.setItem('player', JSON.stringify(player))
    }
}